<template>
  <q-dialog v-model="dialog" persistent class="service-terms-area">
    <q-card style="width: 80%; max-width: 900px">
      <q-card-section class="text-center q-pb-none">
        <span class="service-term-title">サービス利用規約</span>
      </q-card-section>
      <q-separator inset spaced />
      <q-scroll-area
        style="height: 500px; width: 90%; margin: 0 auto; padding-right: 15px"
        visible
        @scroll="setEnableButton"
      >
        <p>弊社サービスのご利用にあたりましては、以下の項目につきご同意頂くものといたします。</p>

        <div class="service-term-item">1. 提供製品の使用目的について</div>
        <p>
          在庫試薬・合成用試薬は、試験研究用途を目的として販売しています。バルク製品（電子材料、農薬原料、化粧品原料、塗料・インキ・接着剤、天然物、機能性材料、高分子材料、医薬品中間体、原薬（API）など）を、
          高次の開発目的（治験薬の製造など）、商業製造などで使用する場合は、詳細について、弊社医薬品営業部あるいは化成品営業部（代表
          03-6262-6467）にお問合せください。
        </p>

        <div class="service-term-item">2. 提供商品の保証期間について</div>
        <p>
          製品の保証期間は、納入後6カ月以内といたします（別途定めがある場合を除きます）。<br />
          製品の品質には細心の注意を払っておりますが、万一不備等があり弊社が妥当と判断した場合、
          当該製品の無償交換または製品代金の返却などの対応をいたします。<br />
          ただし、製品の使用や保管に際して、お客様の故意又は過失などによる損害は、補償、責任を負いかねます。
        </p>
        <p>
          また、試薬の純度については、スクリーニング化合物は90%以上、その他の製品は95%以上を想定しています。
        </p>

        <div class="service-term-item">3. 納期・供給不可品目(欠品)について</div>
        <p>
          輸入作業、合成の遅れなどによる納期の遅れ、ご注文後の欠品、また合成の不成功などが生じるおそれがあります。<br />
          また、上記欠品、合成の不成功等による仕入先サプライヤの切り替えなどにより、当初の見積金額からの変更が生じてしまう場合があります。なお、見積時に提示した納期からの大幅な遅れや欠品、見積金額の変更などが生じた場合は速やかにご連絡いたします。<br />
          納期管理には万全を期しますが、これらの原因により生じた損害につきましては、直接的な損害又は付随的・間接的な損害を問わず、一切の責任を負いかねます。
        </p>

        <div class="service-term-item">4. 化合物の立体表記について</div>
        <p>
          弊社では、見積時に化合物の立体構造を表記する場合、仕入先のサプライヤから提供された情報のまま、記載しています。E体とZ体の区別や、R体とS体の区別、相対配置等については、構造描画上は確定されているように描かれていても、実際には「立体不明」や「混合物」などであるおそれがあります。また、ラセミ体とされているものであっても、一方の立体構造のみが含まれている場合もあります。<br />
        </p>

        <div class="service-term-item">5. 製品の保管について</div>
        <p>
          弊社では、各サプライヤが作成したラベル又はSDSに記載された指示に従い、製品の保管や輸送などを行っております。<br />
        </p>

        <div class="service-term-item">6. 発注後のキャンセルについて</div>
        <p>
          弊社への発注後の、お客様のご都合によるキャンセルはお受けすることができません（別途定めがある場合を除きます）。
        </p>

        <p>本サービス利用規約は予告なしに変更または中止されることがあります。</p>

        <div class="service-term-item">特許権侵害物質排除ポリシー</div>
        <p>
          弊社では、試験研究用途の場合、弊社製品による第三者の特許権の有無およびその侵害について、調査を行っておりません。
        </p>
      </q-scroll-area>
      <q-card-actions align="center" class="q-mt-sm q-mb-md">
        <q-btn
          color="primary"
          label="OK"
          :disable="isBottomScroll"
          style="width: 220px"
          @click="emit('closeDialog', true)"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
<script setup lang="ts">
import { ref, computed } from 'vue';

interface Props {
  // ダイアログ表示フラグ
  isDispDialog: boolean;
}

const props = defineProps<Props>();
const emit = defineEmits(['closeDialog']);

// ダイアログ表示フラグ
const dialog = ref(computed(() => props.isDispDialog));

// スクロールフラグ
const isBottomScroll = ref(true);

/**
 * OKボタンを活性に設定
 * @param verticalPercentage 現在のスクロール位置
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const setEnableButton = ({ verticalPercentage }: any) => {
  // スクロール位置が最下部の場合
  if (verticalPercentage >= 0.8) {
    isBottomScroll.value = false;
  }
};
</script>

<style scoped>
.service-term-title {
  color: var(--q-negative);
  font-size: 1.1rem;
  font-weight: 600;
  text-align: center;
}
.service-term-item {
  font-size: 1rem;
  font-weight: 600;
  color: var(--q-primary);
}
.service-terms-area.q-dialog .q-btn.disabled {
  background-color: var(--q-disabledColor) !important;
}
</style>
